import { RentDurationsLanguages } from '../../@types/types'

export const rentDurationsLanguages: RentDurationsLanguages = {
  monthly: 'per month',
  weekly: 'per week',
  longTerm: 'long term',
  yearly: '1-2 years',
}

export const allRentalDurations: (keyof RentDurationsLanguages)[] = ['monthly', 'weekly', 'longTerm', 'yearly']
